export default "__VITE_ASSET__74da0963__"